import { cn } from '../../../lib/cn'
import type { ResumoGmud } from '../../../types/gmud'
import { COLUNAS, DESCRICAO_DA_LISTA } from './colunas'
import { LinhaDeGmud } from './LinhaDeGmud'

/**
 * A listagem em tabela.
 *
 * Tabela de verdade, com `<th scope="col">`, e não uma grade de `<div>`: é o que permite ao
 * leitor de tela anunciar "Estado: aguardando pauta" ao entrar na célula, em vez de ler uma
 * sequência de textos soltos.
 *
 * Sem cabeçalho fixo ao rolar, e a decisão é deliberada: a barra superior da aplicação é
 * `sticky` e tem altura própria, então um `<th>` grudado no topo precisaria repetir aqui a
 * altura dela em pixels. Esse número envelhece na primeira vez que alguém mexer na barra, e o
 * sintoma é o cabeçalho da tabela desaparecendo por baixo dela — sem erro, sem teste, só
 * errado. Com vinte linhas por página, o rolar é curto e a troca não compensa.
 *
 * @param props as linhas da página corrente
 * @returns a tabela
 */
export function TabelaDeGmuds({ itens }: { itens: ResumoGmud[] }) {
  return (
    <div className="cartao overflow-hidden">
      {/* A rolagem lateral fica NESTA caixa, nunca na página: tabela larga que empurra o
          `<body>` faz o menu e o cabeçalho andarem junto, e aí a tela inteira parece torta. */}
      <div className="overflow-x-auto">
        <table className="min-w-full text-left">
          <caption className="sr-only">{DESCRICAO_DA_LISTA}</caption>
          <thead>
            <tr className="border-b border-slate-200 bg-slate-50">
              {COLUNAS.map((coluna) => (
                <th
                  key={coluna.id}
                  scope="col"
                  className={cn(
                    'cabecalho-de-coluna',
                    coluna.classe,
                  )}
                >
                  {coluna.titulo}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {itens.map((gmud) => (
              <LinhaDeGmud key={gmud.id} gmud={gmud} />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
